import { CanActivateFn, CanMatchFn } from '@angular/router';
import { MpsRoleHelper } from '../../../app/helpers/mps-role.helper';
import { createRoleGuard } from './generic-role.guard';

const guardFunctions = createRoleGuard([MpsRoleHelper.ADMIN]);

export const canActivateUserManagement: CanActivateFn = guardFunctions.canActivate;
export const canMatchUserManagement: CanMatchFn = guardFunctions.canMatch;
